export default __webpack_public_path__ + "static/media/wd-graphics.84bea86f.png";